

import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
     withoutColor?: boolean;
}
    
     function SmartPhone({  withoutColor }: Props): ReactElement {

    return (
      <>
      { withoutColor ?


<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.33203 8.33268C3.33203 5.18999 3.33203 3.61864 4.30834 2.64233C5.28465 1.66602 6.856 1.66602 9.9987 1.66602C13.1414 1.66602 14.7127 1.66602 15.6891 2.64233C16.6654 3.61864 16.6654 5.18999 16.6654 8.33268V11.666C16.6654 14.8087 16.6654 16.3801 15.6891 17.3564C14.7127 18.3327 13.1414 18.3327 9.9987 18.3327C6.856 18.3327 5.28465 18.3327 4.30834 17.3564C3.33203 16.3801 3.33203 14.8087 3.33203 11.666V8.33268Z" stroke="#424242"/>
<path d="M12.5 15.834H7.5" stroke="#424242" strokeLinecap="round"/>
</svg>
:
       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.5" d="M12.0516 2C13.7318 1.99999 15.0627 1.99997 16.1043 2.14245C17.1762 2.28908 18.0438 2.59803 18.728 3.29418C19.4122 3.99033 19.7159 4.87308 19.86 5.9637C20 7.02342 20 8.37752 20 10.087V13.913C20 15.6225 20 16.9766 19.86 18.0363C19.7159 19.1269 19.4122 20.0097 18.728 20.7058C18.0438 21.402 17.1762 21.7109 16.1043 21.8575C15.0627 22 13.7318 22 12.0517 22H11.9484C10.2682 22 8.93729 22 7.89575 21.8575C6.82382 21.7109 5.95621 21.402 5.27199 20.7058C4.58778 20.0097 4.28413 19.1269 4.14001 18.0363C3.99998 16.9766 3.99999 15.6225 4 13.913V10.087C3.99999 8.3775 3.99998 7.02343 4.14001 5.9637C4.28413 4.87308 4.58778 3.99033 5.27199 3.29418C5.95621 2.59803 6.82382 2.28908 7.89575 2.14245C8.93731 1.99997 10.2682 1.99999 11.9484 2H12.0516Z" fill="#07CC66"/>
<path d="M8.57031 18.5112C8.57031 18.1258 8.87731 17.8135 9.25602 17.8135H14.7417C15.1204 17.8135 15.4274 18.1258 15.4274 18.5112C15.4274 18.8965 15.1204 19.2088 14.7417 19.2088H9.25602C8.87731 19.2088 8.57031 18.8965 8.57031 18.5112Z" fill="#07CC66"/>
</svg>


}
      </>
    );
}
export default SmartPhone;

